import React from "react";
import { Filter } from "lucide-react";

interface FilterButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    count?: number;
    label?: string;
    active?: boolean;
}

const FilterButton = React.forwardRef<HTMLButtonElement, FilterButtonProps>(
    ({ count = 0, label, active = false, className = "", ...rest }, ref) => (
        <button
            ref={ref}
            type="button"
            title={label ? undefined : "Filtrer"}
            aria-label={label ? undefined : "Filtrer"}
            {...rest}
            className={`relative flex items-center cursor-pointer hover:bg-gray-100 ${active ? "bg-gray-100" : ""} ${label ? "gap-1.5 px-3 py-1.5 rounded-md" : "p-1"} ${className}`}
        >
            <Filter size={20}/>
            {label && <span className="text-sm">{label}</span>}
            {count > 0 && (
                <span
                    className="absolute -top-1 -right-1 bg-blue-600 text-white rounded-full w-4 h-4 flex items-center justify-center"
                    style={{ fontSize: "10px" }}
                >
                    {count}
                </span>
            )}
        </button>
    )
);

export default FilterButton;
